import { memo } from 'react'
import { useInView } from 'react-intersection-observer'
import { View } from 'react-native'

import { sectionStyles } from './styles'

interface FadeInProps {
  layout: 'header' | 'cover' | 'usp' | 'faq' | 'productsCarousel'
  children: React.ReactNode
  id: string
  threshold?: number
}

const FadeInRenderer = ({ threshold = 0, id, layout, children }: FadeInProps) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold,
  })

  const styles = sectionStyles({
    layout,
  })

  return (
    // @ts-expect-error not compatible with react-native types
    <View ref={ref} className={styles.container({ inView })} id={id}>
      {children}
    </View>
  )
}

export const FadeIn = memo(FadeInRenderer)
